import Configuration from '@/configuration'
import i18next from 'i18next'
import { globals } from '../main.js'
import { _axios } from '../plugins/axios'
import downloadFile from '@/common/downloadFile'

function makeRequest(callback) {
  return globals.$authService
    .getAccessToken()
    .then((response) => {
      callback(response)
    })
    .catch(function (error) {
      //TODO: Acquire token silent failure, send an interactive request.
      new Promise((resolve, reject) => {
        reject(error)
      })
    })
}

const Vue = {}
Vue.$axios = _axios

export default {
  async setProcessManager(data, create) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.$axios({
          method: create ? 'post' : 'put',
          data: data,
          url: Configuration.value('adminEndPoint').concat('/api/ProcessManager/' + (create ? '' : data.id)),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async updateITSupport(data) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.$axios({
          method: 'put',
          url: Configuration.value('adminEndPoint').concat('/api/ITSupport'),
          headers: {
            Authorization: `Bearer ${accessToken}`
          },
          data: data
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async getITSupport() {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.$axios({
          method: 'get',
          url: Configuration.value('adminEndPoint').concat('/api/ITSupport'),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async getRoles() {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.$axios({
          method: 'get',
          url: Configuration.value('adminEndPoint').concat('/api/Roles'),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async getWithCommunityRoles(communityAbbrev) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.$axios({
          method: 'get',
          url: Configuration.value('adminEndPoint').concat('/api/Roles/' + communityAbbrev),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async getProcessManager() {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.$axios({
          method: 'get',
          url: Configuration.value('adminEndPoint').concat('/api/ProcessManager'),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async getCommunity(shortName) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.$axios({
          method: 'get',
          url: Configuration.value('adminEndPoint').concat(`/api/community/${shortName ? `${shortName}` : ''}`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async postCommunity(data) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.$axios({
          method: 'post',
          url: Configuration.value('adminEndPoint').concat('/api/community'),
          headers: {
            Authorization: `Bearer ${accessToken}`
          },
          data: data
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async updateCommunity(data) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.$axios({
          method: 'put',
          url: Configuration.value('adminEndPoint').concat('/api/community/' + data.communityAbbreviation),
          headers: {
            Authorization: `Bearer ${accessToken}`
          },
          data: data
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  replaceUser(data) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.$axios({
          method: 'put',
          data,
          url: Configuration.value('adminEndPoint').concat(`/api/community/${data.communityAbbreviation}/ReplaceUser`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  getDisplayNames(shortName) {
    let displayNames = JSON.parse(JSON.stringify(i18next.getResourceBundle('en')))
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.$axios({
          method: 'get',
          url: Configuration.value('adminEndPoint').concat(`/api/community/${shortName}/DisplayNames`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
          .then((success) => {
            resolve({ ...displayNames, ...success.data })
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async uploadConfigurationFile(file, configurationName, communityAbbreviation) {
    let data = new FormData()
    data.append('configurationFile', file)
    let token = await globals.$authService.getAccessToken()

    return new Promise((resolve, reject) => {
      var axiosRequest = async (accessToken) => {
        Vue.$axios
          .post(
            Configuration.value('adminEndPoint').concat(`/api/community/uploadconfigurationfile/${communityAbbreviation}`),
            data,
            {
              headers: {
                Authorization: `Bearer ${accessToken}`,
                'X-Graph-Token': token,
                'Content-Type': 'multipart/form-data'
              },
              params: { configurationName }
            }
          )
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async getPaginatedQARelationships(communityAbbreviation, params) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.$axios({
          method: 'get',
          url: Configuration.value('adminEndPoint').concat(`/api/community/${communityAbbreviation}/qarelationships`),
          headers: {
            Authorization: `Bearer ${accessToken}`
          },
          params
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async cloneCommunity(params, items) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.$axios({
          method: 'post',
          url: Configuration.value('adminEndPoint').concat(`/api/community/clonecommunity`),
          headers: { Authorization: `Bearer ${accessToken}` },
          params,
          data: items
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async getUsersForPeoplePicker(cancelToken, communityAbbreviation, query, includeInactiveUsers, includeGroups) {
    let token = await globals.$authService.getAccessToken()
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.$axios
          .get(Configuration.value('adminEndPoint').concat(`/api/community/getusers`), {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              'X-Graph-Token': token
            },
            params: { query: query || '', communityAbbreviation, includeInactiveUsers, includeGroups },
            cancelToken: cancelToken
          })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  async getUsersByUserPrincipalName(cancelToken, communityAbbreviation, query) {
    let token = await globals.$authService.getAccessToken()
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.$axios
          .get(Configuration.value('adminEndPoint').concat(`/api/community/GetUsersByUserPrincipalName`), {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              'X-Graph-Token': token
            },
            params: { query: query || '', communityAbbreviation },
            cancelToken: cancelToken
          })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  isCommunityConfidential(communityAbbreviation) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.$axios({
          method: 'get',
          url: Configuration.value('adminEndPoint').concat(`/api/community/${communityAbbreviation}/IsCommunityConfidential`),
          headers: { Authorization: `Bearer ${accessToken}` }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },

  getUserCommunities() {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.$axios({
          method: 'get',
          url: Configuration.value('adminEndPoint').concat(`/api/community/GetUserCommunities`),
          headers: { Authorization: `Bearer ${accessToken}` }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },

  getHelpfulLinks(communityAbbreviation) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.$axios({
          method: 'get',
          url: Configuration.value('adminEndPoint').concat(`/api/community/${communityAbbreviation}/GetHelpfulLinks`),
          headers: { Authorization: `Bearer ${accessToken}` }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },

  getCommunitySummary(communityAbbreviation) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.$axios({
          method: 'get',
          url: Configuration.value('adminEndPoint').concat(`/api/community/${communityAbbreviation}/GetCommunitySummary`),
          headers: { Authorization: `Bearer ${accessToken}` }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }

      makeRequest(axiosRequest)
    })
  },
  getTaskRelationshipReport(communityAbbreviation) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.$axios({
          method: 'get',
          url: Configuration.value('adminEndPoint').concat(`/api/community/${communityAbbreviation}/GetTaskRelationshipReport`),
          headers: { Authorization: `Bearer ${accessToken}` },
          responseType: 'blob'
        })
          .then((success) => {
            downloadFile(
              success.data,
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              `${communityAbbreviation} - Task Relationship Report - ${new Date().toLocaleString()}.xlsx`
            )
            resolve()
          })
          .catch((failure) => {
            reject(failure)
          })
      }
      makeRequest(axiosRequest)
    })
  },
  getTaskRelationshipReportFromMocConfig(community) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.$axios({
          method: 'post',
          url: Configuration.value('adminEndPoint').concat(
            `/api/community/${community.communityAbbreviation}/GetTaskRelationshipReportFromMocConfig`
          ),
          headers: { Authorization: `Bearer ${accessToken}` },
          data: community,
          responseType: 'blob'
        })
          .then((success) => {
            downloadFile(
              success.data,
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              `${community.communityAbbreviation} - Task Relationship Report - ${new Date().toLocaleString()}.xlsx`
            )
            resolve()
          })
          .catch((failure) => {
            reject(failure)
          })
      }
      makeRequest(axiosRequest)
    })
  },
  getTaskRelationships(communityAbbreviation, taskId) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.$axios({
          method: 'get',
          url: Configuration.value('adminEndPoint').concat(
            `/api/community/${communityAbbreviation}/gettaskrelationships/${taskId}`
          ),
          headers: { Authorization: `Bearer ${accessToken}` }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }
      makeRequest(axiosRequest)
    })
  },
  removeSelectedTaskRelationships(communityAbbreviation, taskId, selected) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.$axios({
          method: 'post',
          url: Configuration.value('adminEndPoint').concat(
            `/api/community/${communityAbbreviation}/removeSelectedTaskRelationships/${taskId}`
          ),
          headers: { Authorization: `Bearer ${accessToken}` },
          data: selected
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }
      makeRequest(axiosRequest)
    })
  },
  partialUpdate(communityAbbreviation, community) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.$axios({
          method: 'put',
          url: Configuration.value('adminEndPoint').concat(`/api/community/${communityAbbreviation}/partialupdate`),
          headers: { Authorization: `Bearer ${accessToken}` },
          data: community
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }
      makeRequest(axiosRequest)
    })
  },
  requestTempDbAccess(data) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.$axios({
          method: 'post',
          url: Configuration.value('adminEndPoint').concat(`/api/itsupport/SubmitDbAccessRequest`),
          headers: { Authorization: `Bearer ${accessToken}` },
          data
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }
      makeRequest(axiosRequest)
    })
  },
  setDecisionOnDbAccessRequest(username, decision, communityAbbreviation) {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.$axios({
          method: 'put',
          url: Configuration.value('adminEndPoint').concat(`/api/itsupport/SetDecisionOnDbAccessControl/${username}/${decision}`),
          headers: { Authorization: `Bearer ${accessToken}` },
          params: { communityAbbreviation }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }
      makeRequest(axiosRequest)
    })
  },
  getMyDbAccessControl() {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.$axios({
          method: 'get',
          url: Configuration.value('adminEndPoint').concat(`/api/itsupport/GetMyDbAccessControl`),
          headers: { Authorization: `Bearer ${accessToken}` }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }
      makeRequest(axiosRequest)
    })
  },
  getDbAccessControlPendingApproval() {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.$axios({
          method: 'get',
          url: Configuration.value('adminEndPoint').concat(`/api/itsupport/GetDbAccessControlPendingApproval`),
          headers: { Authorization: `Bearer ${accessToken}` }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }
      makeRequest(axiosRequest)
    })
  },
  getAllCommunities() {
    return new Promise((resolve, reject) => {
      var axiosRequest = (accessToken) => {
        Vue.$axios({
          method: 'get',
          url: Configuration.value('adminEndPoint').concat(`/api/community/GetAll`),
          headers: { Authorization: `Bearer ${accessToken}` }
        })
          .then((success) => {
            resolve(success.data)
          })
          .catch((failure) => {
            reject(failure)
          })
      }
      makeRequest(axiosRequest)
    })
  }
}
